<template>
  <div id="kt_aside" class="aside aside-extended" data-kt-drawer="true" data-kt-drawer-name="aside"
       data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="auto"
       data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle">
    <div class="aside-primary d-flex flex-column align-items-lg-center flex-row-auto">
      <div class="aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto py-10" id="kt_aside_logo">
        <router-link :to="{ name: 'Index' }">
          <img alt="Logo" :src="require('@/assets/logo.svg')" class="h-35px"/>
        </router-link>
      </div>
      <div class="aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0"
           id="kt_aside_nav">
        <div class="hover-scroll-overlay-y mb-5 px-5" data-kt-scroll="true"
             data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto"
             data-kt-scroll-wrappers="#kt_aside_nav" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
             data-kt-scroll-offset="0px">
          <ul class="nav flex-column w-100" id="kt_aside_nav_tabs">
            <li class="nav-item mb-2" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="right"
                data-bs-dismiss="click" title="Menu">
              <a class="nav-link btn btn-icon btn-active-color-primary btn-color-gray-400 btn-active-light active"
                 data-bs-toggle="tab" href="#kt_aside_nav_tab_menu">
                <i class="ki-duotone ki-briefcase fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="aside-footer d-flex flex-column align-items-center flex-column-auto" id="kt_aside_footer">
        <div class="mb-5" title="Выйти">
          <svg @click="logout" class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#F44336">
            <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-84 31.5-156.5T197-763l56 56q-44 44-68.5 102T160-480q0 134 93 227t227 93q134 0 227-93t93-227q0-67-24.5-125T707-707l56-56q54 54 85.5 126.5T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-360v-440h80v440h-80Z"/>
          </svg>
        </div>
        <div class="d-flex align-items-center mb-10">
          <slot name="tokenProgress"></slot>
        </div>
      </div>
    </div>
    <div class="aside-secondary d-flex flex-row-fluid">
      <div class="aside-workspace my-5 p-5" id="kt_aside_wordspace">
        <div class="d-flex h-100 flex-column">
          <div class="flex-column-fluid hover-scroll-y"
               data-kt-scroll="true"
               data-kt-scroll-activate="true"
               data-kt-scroll-height="auto"
               data-kt-scroll-wrappers="#kt_aside_wordspace"
               data-kt-scroll-dependencies="#kt_aside_secondary_footer"
               data-kt-scroll-offset="0px">
            <div class="tab-content">
              <div class="tab-pane fade active show" id="kt_aside_nav_tab_menu" role="tabpanel">
                <div
                    class="menu menu-column menu-fit menu-rounded menu-title-gray-600 menu-icon-gray-400 menu-state-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold fs-6 px-2 my-5 my-lg-0"
                    id="kt_aside_menu" data-kt-menu="true">
                  <div id="kt_aside_menu_wrapper" class="menu-fit">
                    <div class="menu-item">
                      <div class="menu-content pt-0">
                        <span class="menu-heading fw-bold text-uppercase fs-7">Главная</span>
                      </div>
                      <router-link :to="{ name: 'Index' }" class="menu-link">
                        <span class="menu-icon">
                          <i class="ki-duotone ki-element-11 fs-2">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                            <span class="path4"></span>
                          </i>
                        </span>
                        <span class="menu-title">Главная</span>
                      </router-link>
                      <router-link v-if="roleAdmin.includes(this.$user.role)" :to="{ name: 'Dashboard' }" class="menu-link">
                        <span class="menu-icon">
                          <i class="ki-duotone ki-rocket fs-2">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </i>
                        </span>
                        <span class="menu-title">Информация</span>
                      </router-link>
                      <router-link v-if="roleGroupSale.includes(this.$user.role) || roleModerator.includes(this.$user.role) || roleAccountant.includes(this.$user.role)" :to="{ name: 'Branches' }" class="menu-link">
                        <span class="menu-icon">
                          <i class="ki-duotone ki-data fs-2">
                           <i class="path1"></i>
                           <i class="path2"></i>
                           <i class="path3"></i>
                           <i class="path4"></i>
                           <i class="path5"></i>
                          </i>
                        </span>
                        <span class="menu-title">Сотрудники</span>
                      </router-link>
                      <router-link v-if="roleGroupSale.includes(this.$user.role)" :to="{ name: 'Drafts' }" class="menu-link">
                        <span class="menu-icon">
                          <i class="ki-duotone ki-tablet-book fs-2">
                           <span class="path1"></span>
                           <span class="path2"></span>
                          </i>
                        </span>
                        <span class="menu-title">Черновики</span>
                      </router-link>
                      <router-link v-if="roleGroupSale.includes(this.$user.role) || roleAccountant.includes(this.$user.role)" :to="{ name: 'Policies' }" class="menu-link">
                        <span class="menu-icon">
                          <i class="ki-duotone ki-tablet-ok fs-2">
                           <span class="path1"></span>
                           <span class="path2"></span>
                           <span class="path3"></span>
                          </i>
                        </span>
                        <span class="menu-title" v-html="this.$user.role === 5 ? 'Мои договоры' : 'Договоры'"></span>
                      </router-link>
                    </div>
                    <template v-if="roleDRM.includes(this.$user.role)">
                      <div class="menu-item pt-5">
                        <div class="menu-content">
                          <span class="menu-heading fw-bold text-uppercase fs-7">ДРМ</span>
                        </div>
                      </div>
                      <div class="menu-item">
                        <router-link :to="{ name: 'Podft' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-faceid fs-2">
                             <span class="path1"></span>
                             <span class="path2"></span>
                             <span class="path3"></span>
                             <span class="path4"></span>
                             <span class="path5"></span>
                             <span class="path6"></span>
                            </i>
                          </span>
                          <span class="menu-title">ПОДФТ</span>
                        </router-link>
                      </div>
                    </template>
                    <template v-if="roleGroupSale.includes(this.$user.role)">
                      <div class="menu-item pt-5">
                        <div class="menu-content">
                          <span class="menu-heading fw-bold text-uppercase fs-7">Продукты</span>
                        </div>
                        <router-link v-if="roleGroupReserveSale.includes(this.$user.role) && (this.$user.role === 8 ? !!this.$user.apc : true)" :to="{ name: 'Ogpo' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-file fs-2">
                              <span class="path1"></span>
                              <span class="path2"></span>
                            </i>
                          </span>
                          <span class="menu-title">ОГПО ВТС</span>
                        </router-link>
                        <template v-if="roleGroupMainSale.includes(this.$user.role)">
                          <div class="menu-content pt-0 pb-1">
                            <span class="menu-heading fs-7 ms-1">Финансовые институты</span>
                          </div>
                          <router-link :to="{ name: 'Properties' }" class="menu-link ms-3">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-file fs-2">
                              <span class="path1"></span>
                              <span class="path2"></span>
                            </i>
                          </span>
                            <span class="menu-title">Имущество</span>
                          </router-link>
                          <router-link :to="{ name: 'Casco' }" class="menu-link ms-3">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-file fs-2">
                              <span class="path1"></span>
                              <span class="path2"></span>
                            </i>
                          </span>
                            <span class="menu-title">Каско</span>
                          </router-link>
                        </template>
                      </div>
                    </template>
                    <template v-if="roleGroupTermination.includes(this.$user.role) || roleGroupRewrite.includes(this.$user.role)">
                      <div class="menu-item pt-5">
                        <div class="menu-content">
                          <span class="menu-heading fw-bold text-uppercase fs-7">Функционал</span>
                        </div>
                      </div>
                      <div class="menu-item">
                        <router-link :to="{ name: 'Termination' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-shop fs-2">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                            <span class="path4"></span>
                            <span class="path5"></span>
                          </i>
                          </span>
                          <span class="menu-title">Расторжение</span>
                        </router-link>
                      </div>
                      <!-- <div class="menu-item">
                        <router-link :to="{ name: 'Rewrite' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-shop fs-2">
                              <span class="path1"></span>
                              <span class="path2"></span>
                              <span class="path3"></span>
                              <span class="path4"></span>
                              <span class="path5"></span>
                            </i>
                          </span>
                          <span class="menu-title">Переоформление</span>
                        </router-link>
                      </div> -->
                    </template>
                    <template v-if="roleAdmin.includes(this.$user.role)">
                      <div class="menu-item pt-5">
                        <div class="menu-content">
                          <span class="menu-heading fw-bold text-uppercase fs-7">Админ</span>
                        </div>
                      </div>
                      <div class="menu-item">
                        <router-link :to="{ name: 'Products' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-shop fs-2">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                            <span class="path4"></span>
                            <span class="path5"></span>
                          </i>
                          </span>
                          <span class="menu-title">Продукты</span>
                        </router-link>
                        <router-link :to="{ name: 'Versions' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-information fs-2">
                             <span class="path1"></span>
                             <span class="path2"></span>
                             <span class="path3"></span>
                            </i>
                          </span>
                          <span class="menu-title">Версии</span>
                        </router-link>
                        <router-link :to="{ name: 'Agreement' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-double-check-circle fs-2">
                             <span class="path1"></span>
                             <span class="path2"></span>
                             <span class="path3"></span>
                            </i>
                          </span>
                          <span class="menu-title">На согласование</span>
                        </router-link>
                      </div>
                    </template>
                    <template v-if="roleSupport.includes(this.$user.role)">
                      <div class="menu-item pt-5">
                        <div class="menu-content">
                          <span class="menu-heading fw-bold text-uppercase fs-7">Тех. Поддержка</span>
                        </div>
                      </div>
                      <div class="menu-item">
                        <router-link :to="{ name: 'OperatorError' }" class="menu-link">
                          <span class="menu-icon">
                            <i class="ki-duotone ki-shield-tick fs-2">
                              <span class="path1"></span>
                              <span class="path2"></span>
                              <span class="path3"></span>
                            </i>
                          </span>
                          <span class="menu-title">Ошибки оператора</span>
                        </router-link>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button id="kt_aside_toggle"
            class="aside-toggle btn btn-sm btn-icon bg-body btn-color-gray-700 btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm d-none d-lg-flex mb-18"
            data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body"
            data-kt-toggle-name="aside-minimize">
      <i class="ki-duotone ki-arrow-left fs-2 rotate-180">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
    </button>
  </div>
</template>

<script>
import permissions from '@/helpers/permissions';
export default {
  name: 'VAside',
  components: {permissions},
  computed: {
    roleDRM() {
      return permissions.drm()
    },
    roleModerator() {
      return permissions.moderator()
    },
    roleGroupSale() {
      return permissions.groupSale()
    },
    roleGroupMainSale() {
      return permissions.groupMainSale()
    },
    roleGroupReserveSale() {
      return permissions.groupReserveSale()
    },
    roleAdmin() {
      return permissions.admin()
    },
    roleAccountant() {
      return permissions.accountant()
    },
    roleSupport() {
      return permissions.support() 
    },
    roleGroupTermination() {
      return permissions.groupTermination()
    },
    roleGroupRewrite() {
      return permissions.groupRewrite()
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('access')
      localStorage.removeItem('ttl')
      localStorage.removeItem('user')
      localStorage.removeItem('ttlDate')
      window.location.href = '/login'
    },
  }
}
</script>

<style scoped>

</style>